import { createSelector } from 'reselect';
import { concat, every, filter, flatMap, flow, join, get, map, values } from 'lodash/fp';

const playersSquadSelector = createSelector(
  get('challenge.players'),
  get('challenge.playerPositions'),
  get('challenge.labels'),
  get('playerList.playerTypeFilters'),
  (players, playerPositions, labels, playerTypeFilters) =>
    flow(
      filter(p => every(x => p[x], playerTypeFilters)),
      flatMap(p =>
        map(
          pos => ({
            id: p.id,
            name: p.name,
            team: p.teamName,
            opposition: p.isHome ? p.awayTeam : p.homeTeam,
            position: pos.short_label || pos.key,
            salary: p.salary,
            average: p.average,
            form: p.form,
            number: p.number,
            leg: `Leg ${p.gameOrder}`,
            gameNumber: get('gameNumber', p),
            gameVenue: get('gameVenue', p),
            place: p.place,
            placeProjected: p.placeProjected,
            playingStatus: flow(
              map(
                playerLabel =>
                  get(
                    'description',
                    labels.find(challengeLabel => challengeLabel.name === playerLabel.name)
                  ) || playerLabel.name
              ),
              join(', ')
            )(p.labels),
            score: p.score,
            popularity: p.popularity,
            weight: p.weight,
            win: p.win,
            winProjected: p.winProjected
          }),
          p.positions
        )
      )
    )(values(players))
);

const teamsSquadSelector = createSelector(
  get('challenge.teams'),
  get('challenge.teamPositions'),
  (teams, teamPositions) =>
    flatMap(
      t =>
        map(
          pos => ({
            id: `T${t.id}`,
            name: t.name,
            team: t.teamName,
            opposition: t.isHome ? t.awayTeam : t.homeTeam,
            position: pos.abbr,
            salary: t.salary,
            average: t.average,
            form: t.form
          }),
          values(teamPositions)
        ),
      values(teams)
    )
);

const squadSelector = createSelector(playersSquadSelector, teamsSquadSelector, concat);

export default squadSelector;
